import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import VideoRecorder from "react-video-recorder";
import { toast } from "react-toastify";
import { setLoading } from "redux/common/commonAction";
import { handleVisualVerify, onSubmitVisualVerify } from "./redux/action";
import {
  makeid,
  showPrevBtnByUrl,
  showNextBtnByUrl,
  getPrevAndNextRoute,
} from "utils";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import "./style.css";
import axios from "axios";

function VisualVerification() {
  let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
  API_URL_NEW = API_URL_NEW
    ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
    : "";
  const dispatch = useDispatch();
  const history = useHistory();
  const { ApiError } = useSelector((state) => state.visual);
  const { inputLabelColor, inputError } = useSelector((state) => state.theme);
  const { kycStatus, kycPageName } = useSelector((state) => state.navigation);
  const [videoBlob, setVideoBlob] = useState(null);
  const [showImgModal, setImgShowModal] = useState({
    show: false,
    data: "",
  });
  // const [videoUrl, setVideoUrl] = useState(null);
  // const [image, setImage] = useState("");
  const [number, setNumber] = useState({
    num1: "",
    num2: "",
  });
  // const [lat, setLat] = useState("");
  // const [long, setLong] = useState("");
  // const [ipcity, setIpCity] = useState("");
  const [sum, setSum] = useState("");
  const [tempSum, setTempSum] = useState(0);
  const [captchaResult, setCaptchaResult] = useState([]);
  const [captchaIsValid, setCaptchaIsValid] = useState(null);

  useEffect(() => {
    reloadCaptcha();
  }, []);

  useEffect(() => {
    const total = number.num1 + number.num2;
    setTempSum(total);
    let random,
      arr = [total, total + 2];
    random = randomArrayShuffle(arr);
    setCaptchaResult(random);
  }, [number]);

  // useEffect(() => {
  //   function getLocation() {
  //     if (navigator.geolocation) {
  //       navigator.geolocation.getCurrentPosition(showPosition);
  //     } else {
  //     }
  //   }
  //   getLocation();
  // }, [navigator]);

  useEffect(() => {
    if (ApiError) {
      setVideoBlob(null);
      setSum(false);
    }
  }, [ApiError]);

  // function showPosition(position) {
  //   setLat(position?.coords?.latitude);
  //   setLong(position?.coords?.longitude);
  // }

  const randomArrayShuffle = (array) => {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  };

  const reloadCaptcha = () => {
    setNumber({
      num1: Math.floor(Math.random() * 2) + 1,
      num2: Math.floor(Math.random() * 2) + 1,
    });
    setCaptchaIsValid("");
  };

  const submitCaptcha = (e) => {
    setSum(e.target.value);
    let parseNum = parseInt(e.target.value);
    if (tempSum === parseNum) {
      setCaptchaIsValid(1);
      handleVerification();
    } else {
      setCaptchaIsValid(0);
    }
  };

  const handleBlob = (blob) => {
    setVideoBlob(blob);
  };

  const visualVerifyCallback = (data) => {
    setImgShowModal({
      show: true,
      data: data.data,
    });
  };

  const handleVerification = async () => {
    if (!videoBlob) {
      return toast.error("Error: Please try again.");
    }
    dispatch(setLoading(true));
    const formData = new FormData();
    formData.append("files", videoBlob, makeid(6));
    formData.append("question", `${number.num1} + ${number.num2}`);
    formData.append("answer", tempSum);
    // formData.append("latitude", lat);
    // formData.append("longitude", long);
    dispatch(handleVisualVerify(formData, visualVerifyCallback));
  };

  const handleSubmit = () => {
    dispatch(onSubmitVisualVerify());
  };

  const handleStopVideo = () => {
    setVideoBlob(null);
    setSum(false);
  };

  //send email or sms link
  const [showLinkToSend, setShowLinkToSend] = useState(false);
  const [isLinkSendLoading, setIsLinkSendLogin] = useState(false);
  let brokerID = window.sessionStorage.getItem("broker_id");
  let isThroughLink = window.sessionStorage.getItem("is_through_link");
  let token = window.sessionStorage.getItem("token");
  let baseURL = window.location.origin.toString();
  //  ./send email or sms link

  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";

  const onSendEmailPress = async () => {
    setIsLinkSendLogin(true);
    const headers = {
      headers: {
        Authorization: `Basic ${token}`,
      },
    };
    const resp = await axios.post(
      `${API_URL}/api/method/kyc_customizations.apis.session.sendsessionstartmail`,
      {},
      headers
    );
    setShowLinkToSend(true);
    setIsLinkSendLogin(false);
    console.log(resp);
  };
  const handleCloseImgModal = () => {
    setVideoBlob(null);
    setSum(false);
    setImgShowModal({
      show: false,
      data: null,
    });
    return toast.error("Error: Please upload new video.");
  };

  return (
    <div className="col-md-9">
      <Title title="Visual Verification" />
      <Modal show={showLinkToSend}>
        <Modal.Header>Send link as email</Modal.Header>
        <Modal.Body>
          <small>
            We have sent you an email with link. kindly check your email.
            <br /> <br />
            Or You can use the below link to share with your other device with
            camera.
            <br />
            <br />
          </small>
          <pre>
            <code>{baseURL + "/d/" + brokerID + "/" + token}</code>
          </pre>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger"
            onClick={() => setShowLinkToSend(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
      <div className="col-md-12">
        <div
          style={{ background: "rgba(12,171,196, 0.1)", borderRadius: 20 }}
          className="px-5 py-3"
        >
          <div style={{ color: inputLabelColor, fontWeight: "bold" }}>
            Capture Video
          </div>
          <div
            style={{ color: inputLabelColor, fontSize: 12 }}
            className="my-1"
          >
            Ensure that your face is clearly visible in the video. (4 to 5
            seconds of video is fine)
          </div>
          <div
            style={{ color: "#F00", fontSize: 14, fontWeight: "500" }}
            className="mb-2"
          >
            Note: Rotate face 45 degree left and 45 degree right.
          </div>
          <div className="video">
            <VideoRecorder
              replayVideoAutoplayAndLoopOff={true}
              onRecordingComplete={(blob) => {
                handleBlob(blob);
              }}
              onStopReplaying={() => handleStopVideo()}
              timeLimit={10000}
            />
          </div>
          {videoBlob && (
            <div className="mt-2">
              <span
                className="numbrs"
                style={{ color: inputLabelColor }}
              >
                What is {number.num1} + {number.num2} = ?
              </span>
              {captchaResult.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="custom-control custom-radio custom-control-inline mx-1"
                  >
                    <input
                      type="radio"
                      id="radio1"
                      className="form-check-input"
                      value={item}
                      checked={item == sum ? true : false}
                      onChange={submitCaptcha}
                    />{" "}
                    &nbsp;
                    <label className="custom-control-label">{item}</label>
                  </div>
                );
              })}
              {captchaIsValid === 0 ? (
                <div style={{ color: inputError }}>Invalid captcha</div>
              ) : (
                ""
              )}
            </div>
          )}
          {isThroughLink != "true" && (
            <div
              className="mt-2"
              style={{ textAlign: "right" }}
            >
              <button
                className="btn"
                onClick={() => onSendEmailPress()}
              >
                <small>
                  {!isLinkSendLoading ? (
                    "Send link as Email"
                  ) : (
                    <div
                      className="spinner-border text-dark text-sm"
                      role="status"
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  )}
                </small>
              </button>
            </div>
          )}
          <div className="col-md-12 d-flex mt-4">
            {showPrevBtnByUrl(
              history.location.pathname,
              kycStatus,
              kycPageName
            ) && (
              <Button
                title="Previous"
                type="button"
                className="mx-1"
                handleClick={() => {
                  const route = getPrevAndNextRoute(
                    history.location.pathname.slice(1),
                    kycPageName
                  );
                  history.push(route.prev);
                }}
              />
            )}
            {showNextBtnByUrl(
              history.location.pathname,
              kycStatus,
              kycPageName
            ) && (
              <Button
                title="Next"
                type="button"
                className="mx-1"
                handleClick={() => {
                  const route = getPrevAndNextRoute(
                    history.location.pathname.slice(1),
                    kycPageName
                  );
                  history.push(route.next);
                }}
              />
            )}
          </div>
        </div>
      </div>
      <Modal
        show={showImgModal.show}
        onHide={handleCloseImgModal}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="d-flex align-item-center justify-content-center">
            <img
              src={showImgModal.data?.url}
              className="img-fluid"
              alt=""
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            title="Cancel"
            handleClick={() => handleCloseImgModal()}
          />
          <Button
            title="Submit"
            handleClick={() => handleSubmit()}
          />
        </Modal.Footer>
      </Modal>
      <div>
        {/* <div style={{ display: "flex" }}> */}
        {/* <span className="numbrs">
            What is {number.num1} + {number.num2} = ?
          </span>
          {captchaResult.map((item, index) => {
            return (
              <div
                key={index}
                className="custom-control custom-radio custom-control-inline mx-1"
              >
                <input
                  type="radio"
                  id="radio1"
                  className="custom-control-input"
                  value={item}
                  checked={item == sum ? true : false}
                  onChange={submitCaptcha}
                />
                <label className="custom-control-label">{item}</label>
              </div>
            );
          })}
          <button type="button" className="mx-1" onClick={reloadCaptcha}>
            <i className="fas fa-sync"></i>
          </button>
        </div> */}

        {/* <div className="col-md-12 mt-3">
          <Button type="button" title="Submit" handleClick={handleSubmit} />
        </div> */}
      </div>
    </div>
  );
}

// NEW CODE HERE
// const WIDTH = 500;
// const HEIGHT = 500;
// const inputSize = 160;

// const videoConstraints = {
//   width: WIDTH,
//   height: HEIGHT,
//   facingMode: "user",
// };

// const VisualVerification = () => {
//   let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
//   API_URL_NEW = API_URL_NEW
//     ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
//     : "";
//   const dispatch = useDispatch();
//   const { inputLabelColor, inputError } = useSelector((state) => state.theme);
//   const webcamRef = useRef(null);
//   const mediaRecorderRef = useRef(null);
//   const [videoBlob, setVideoBlob] = useState(null);
//   const [location, setLocation] = useState("");
//   const [capturing, setCapturing] = useState(false);
//   const [recordedChunks, setRecordedChunks] = useState([]);
//   const [imgDesc, setImgDesc] = useState({
//     detections: [],
//     expression: null,
//   });
//   const [showCamera, setShowCamera] = useState(false);
//   const [moods, setMoods] = useState([
//     {
//       name: "neutral",
//       img: "",
//       verify: false,
//     },
//     {
//       name: "happy",
//       img: "",
//       verify: false,
//     },
//     {
//       name: "sad",
//       img: "",
//       verify: false,
//     },
//     {
//       name: "angry",
//       img: "",
//       verify: false,
//     },
//     {
//       name: "fearful",
//       img: "",
//       verify: false,
//     },
//     {
//       name: "disgusted",
//       img: "",
//       verify: false,
//     },
//     {
//       name: "surprised",
//       img: "",
//       verify: false,
//     },
//   ]);
//   const [isMood, setIsMood] = useState(false);
//   const [number, setNumber] = useState({
//     num1: "",
//     num2: "",
//   });
//   const [sum, setSum] = useState("");
//   const [tempSum, setTempSum] = useState(0);
//   const [captchaResult, setCaptchaResult] = useState([]);
//   const [captchaIsValid, setCaptchaIsValid] = useState(null);

//   const capture = async () => {
//     if (!!webcamRef.current) {
//       await getFaceDetection(webcamRef.current.getScreenshot(), inputSize).then(
//         (resp) => {
//           if (resp?.length > 0) {
//             const objArr = resp[0];
//             const max = Math.max.apply(
//               Math,
//               objArr.expressions.map(function (o) {
//                 return o.probability;
//               })
//             );
//             const objValue = objArr.expressions.filter((item) => {
//               return item.probability === max;
//             })[0];
//             setImgDesc({
//               ...imgDesc,
//               detections: [objArr.detection],
//               expression: objValue.expression,
//             });
//             const moodArr = moods;
//             moodArr.forEach((y, i) => {
//               if (y.name === objValue.expression) {
//                 moodArr[i] = {
//                   ...y,
//                   img: webcamRef.current?.getScreenshot(),
//                   verify: true,
//                 };
//                 setMoods(moodArr);
//                 setIsMood(moodArr[i]);
//               }
//             });
//           }
//         }
//       );
//     }
//   };

//   useEffect(() => {
//     const interval = setInterval(() => {
//       capture();
//     }, 1000);
//     return () => clearInterval(interval);
//   }, []);

//   useEffect(() => {
//     const getLocation = async () => {
//       try {
//         const resp = await fetch("https://geolocation-db.com/json/");
//         const json = await resp.json();
//         setLocation(json);
//       } catch (error) {}
//     };
//     getLocation();
//   }, []);

//   const reloadCaptcha = () => {
//     setNumber({
//       num1: Math.floor(Math.random() * 2) + 1,
//       num2: Math.floor(Math.random() * 2) + 1,
//     });
//     setSum("");
//     setCaptchaIsValid("");
//   };

//   const randomArrayShuffle = (array) => {
//     var currentIndex = array.length,
//       temporaryValue,
//       randomIndex;
//     while (0 !== currentIndex) {
//       randomIndex = Math.floor(Math.random() * currentIndex);
//       currentIndex -= 1;
//       temporaryValue = array[currentIndex];
//       array[currentIndex] = array[randomIndex];
//       array[randomIndex] = temporaryValue;
//     }
//     return array;
//   };

//   useEffect(() => {
//     reloadCaptcha();
//   }, []);

//   useEffect(() => {
//     const total = number.num1 + number.num2;
//     setTempSum(total);
//     let random,
//       arr = [total, total + 2];
//     random = randomArrayShuffle(arr);
//     setCaptchaResult(random);
//   }, [number]);

//   function capitalizeFirstLetter(string) {
//     return string.charAt(0).toUpperCase() + string.slice(1);
//   }

//   const submitCaptcha = (e) => {
//     setSum(e.target.value);
//     let parseNum = parseInt(e.target.value);
//     if (tempSum === parseNum) {
//       setCaptchaIsValid(1);
//       handleVerification();
//     } else {
//       setCaptchaIsValid(0);
//     }
//   };

//   const checkMoodArrLength = () => {
//     return moods.filter((y) => y.verify);
//   };

//   // useEffect(() => {
//   //   let total = 0;
//   //   for (let i in moods) {
//   //     if (moods[i].verify) {
//   //       total++;
//   //     }
//   //   }
//   //   if (total >= 4) {
//   //     setShowCamera(false);
//   //   } else {
//   //     setShowCamera(true);
//   //   }
//   // }, [isMood]);

//   useEffect(() => {
//     if (checkMoodArrLength().length === 1 && !capturing) {
//       handleStartCaptureClick();
//     } else if (checkMoodArrLength().length >= 2) {
//       handleStopCaptureClick();
//     }
//   }, [isMood]);

//   useEffect(() => {
//     if (checkMoodArrLength().length === 2 && recordedChunks.length > 0) {
//       handleDownload();
//     }
//   }, [recordedChunks]);

//   const handleStartCaptureClick = React.useCallback(() => {
//     console.log("handleStartCaptureClick");
//     setCapturing(true);
//     mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
//       mimeType: "video/webm",
//     });
//     mediaRecorderRef.current.addEventListener(
//       "dataavailable",
//       handleDataAvailable
//     );
//     mediaRecorderRef.current.start();
//   }, [webcamRef, setCapturing, mediaRecorderRef]);
//   const handleDataAvailable = React.useCallback(
//     ({ data }) => {
//       console.log("handleDataAvailable", data);
//       if (data.size > 0) {
//         setRecordedChunks((prev) => prev.concat(data));
//       }
//     },
//     [setRecordedChunks]
//   );

//   const handleStopCaptureClick = React.useCallback(() => {
//     if (mediaRecorderRef.current.state === "recording") {
//       mediaRecorderRef.current.stop();
//       setCapturing(false);
//     }
//   }, [mediaRecorderRef, webcamRef, setCapturing]);

//   const handleDownload = () => {
//     console.log("recordedChunks", recordedChunks);
//     const blob = new Blob(recordedChunks, {
//       type: "video/webm",
//     });
//     console.log("blob---", blob);
//     setVideoBlob(blob);
//     toast.success("You are eligible to submit video verification");
//   };

//   const handleShowCamera = () => {
//     setShowCamera(!showCamera);
//   };

//   const handleVerification = async () => {
//     setShowCamera(false);

//     dispatch(setLoading(true));
//     const formData = new FormData();
//     formData.append("files", videoBlob);
//     formData.append("ip", location.IPv4);
//     formData.append("question", `${number.num1} + ${number.num2}`);
//     formData.append("answer", tempSum);
//     formData.append("latitude", location.latitude);
//     formData.append("longitude", location.longitude);
//     formData.append("lat_long_city", location.city);
//     dispatch(handleVisualVerify(formData));
//   };

//   const getDrawBox = () => {
//     let drawBox = null;
//     if (!!imgDesc.detections) {
//       drawBox = imgDesc.detections.map((item, i) => {
//         let _H = item.box.height;
//         let _W = item.box.width;
//         let _X = item.box._x;
//         let _Y = item.box._y;
//         return (
//           <div key={i}>
//             <div
//               style={{
//                 position: "absolute",
//                 border: "solid",
//                 borderColor: "blue",
//                 height: _H,
//                 width: _W,
//                 transform: `translate(${_X}px,${_Y}px)`,
//               }}
//             >
//               {!!imgDesc.expression ? (
//                 <p
//                   style={{
//                     backgroundColor: "blue",
//                     border: "solid",
//                     borderColor: "blue",
//                     width: _W,
//                     marginTop: 0,
//                     color: "#fff",
//                     transform: `translate(-3px,${_H}px)`,
//                   }}
//                 >
//                   {capitalizeFirstLetter(imgDesc.expression)}
//                 </p>
//               ) : null}
//             </div>
//           </div>
//         );
//       });
//     }
//     return drawBox;
//   };

//   return (
//     <div className="App">
//       <Title title="Visual Verification" />
//       <div className="col-md-12">
//         <div
//           style={{ background: "rgba(12,171,196, 0.1)", borderRadius: 20 }}
//           className="px-5 py-3"
//         >
//           <div style={{ color: inputLabelColor, fontWeight: "bold" }}>
//             Capture Video
//           </div>
//           <div
//             style={{ color: inputLabelColor, fontSize: 12 }}
//             className="mb-3"
//           >
//             Ensure that your face is clearly visible and need atleast 2 emotions to verify.
//           </div>

//           {showCamera && (
//             <div
//               className="Camera"
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 margin: "20px",
//               }}
//             >
//               <div
//                 style={{
//                   width: WIDTH,
//                   height: HEIGHT,
//                 }}
//               >
//                 <div style={{ position: "relative", width: WIDTH }}>
//                   {!!videoConstraints ? (
//                     <div style={{ position: "absolute" }}>
//                       <Webcam
//                         ref={webcamRef}
//                         audio={false}
//                         width={WIDTH}
//                         height={HEIGHT}
//                         screenshotFormat="image/jpeg"
//                         videoConstraints={videoConstraints}
//                       />
//                     </div>
//                   ) : null}
//                   {getDrawBox()}
//                 </div>
//               </div>
//               <div style={{ margin: "20px" }}>
//                 {moods.map((item, index) => {
//                   return (
//                     <div
//                       className="form-check"
//                       key={index}
//                       style={{ pointerEvents: "none" }}
//                     >
//                       <input
//                         className="form-check-input"
//                         type="checkbox"
//                         checked={item.verify}
//                       />
//                       <label style={{ color: "#000" }}>
//                         {capitalizeFirstLetter(item.name)}
//                       </label>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}
//           {checkMoodArrLength().length >= 2 && (
//             <div>
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   justifyContent: "center",
//                   alignItems: "center",
//                 }}
//               >
//                 {captchaIsValid === 0 ? (
//                   <div style={{ color: inputError, textAlign: "center" }}>
//                     Invalid captcha
//                   </div>
//                 ) : null}
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                   }}
//                 >
//                   <span className="numbrs">
//                     What is {number.num1} + {number.num2} = ?
//                   </span>
//                   {captchaResult.map((item, index) => {
//                     return (
//                       <div
//                         key={index}
//                         className="custom-control custom-radio custom-control-inline mx-1"
//                       >
//                         <input
//                           type="radio"
//                           id="radio1"
//                           className="custom-control-input"
//                           value={item}
//                           checked={item == sum ? true : false}
//                           onChange={submitCaptcha}
//                         />
//                         <label className="custom-control-label">{item}</label>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   marginTop: "10px",
//                 }}
//               >
//                 <button type="button" onClick={() => reloadCaptcha()}>
//                   <i class="fa fa-refresh" aria-hidden="true"></i>
//                 </button>
//               </div>
//             </div>
//           )}
//           {!showCamera && (
//             <div className="col-md-12 mt-3">
//               <Button
//                 type="button"
//                 title="Click To Start"
//                 handleClick={handleShowCamera}
//               />
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

export default VisualVerification;
